import { mapGetters, mapActions } from 'vuex'

const moduleName = 'contacts'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff'
    })
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'addStoreItem', 'saveSnapshot', 'clearSnapshots', 'addNewEntity', 'setReturnRoute']),
    ...mapActions('quickinvoices', {setQuickInvoiceContactId: 'setContactId'}),
    ...mapActions('sundrycreditors', {setSundryCreditorContact: 'setContact'}),
    ...mapActions('purchaseorders', {setPurchaseOrderContact: 'setContact'}),
    ...mapActions('printpreview', { setPrintPreviewReturnRoute: 'setReturnRoute', addEmailer: 'addEmailer', removeEmailer: 'removeEmailer' }),
    ...mapActions('printpreview', { addReportParameters: 'addParameters', removeReportParameters: 'removeParameters' })
  }
}
